export const CompanyListConstant = {
    StoreSliceName: 'companyList',
};
